/* ============================================================
   BONLIFE MENA — lightweight theme JS
   No dependencies. Each behaviour is feature-detected so the
   script is safe to load on every template.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Header: subtle shadow on scroll ---- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.style.boxShadow = window.scrollY > 20 ? '0 1px 20px -10px rgba(43,38,34,.4)' : 'none';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile navigation drawer ---- */
  var drawer = document.querySelector('[data-mobile-nav]');
  var overlay = document.querySelector('[data-mobile-overlay]');
  var openBtns = document.querySelectorAll('[data-mobile-open]');
  var closeBtn = document.querySelector('[data-mobile-close]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (overlay) overlay.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  openBtns.forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  if (overlay) overlay.addEventListener('click', function () { setDrawer(false); });

  /* ---- Accordions (PDP & anywhere with [data-acc]) ---- */
  document.querySelectorAll('[data-acc-item]').forEach(function (item) {
    var head = item.querySelector('[data-acc-head]');
    var body = item.querySelector('[data-acc-body]');
    if (!head || !body) return;
    var sync = function () {
      body.style.maxHeight = item.classList.contains('is-open') ? body.scrollHeight + 'px' : '0px';
      head.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
    };
    sync();
    head.addEventListener('click', function () { item.classList.toggle('is-open'); sync(); });
  });

  /* ---- Newsletter inline success message ---- */
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    document.querySelectorAll('[data-newsletter-success]').forEach(function (ok) {
      ok.removeAttribute('hidden');
    });
  }
})();

/* ============================================================
   Media banner — image rotation and reduced-motion handling.
   Separate IIFE so it stays independent of the block above.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-mbanner-slides]').forEach(function (wrap) {
    var slides = wrap.querySelectorAll('[data-mbanner-slide]');
    if (slides.length < 2 || reduceMotion) return;

    var speed = parseInt(wrap.getAttribute('data-speed'), 10) || 5000;
    var index = 0;
    var timer = null;

    function show(n) {
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === n); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();                                  /* guard against stacked intervals */
      timer = setInterval(function () {
        index = (index + 1) % slides.length;
        show(index);
      }, speed);
    }

    start();
    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });
  });

  /* Background video autoplays muted; honour a reduced-motion preference. */
  if (reduceMotion) {
    document.querySelectorAll('[data-mbanner-video]').forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }
})();

/* ============================================================
   Announcement bar — messages sit side by side on desktop and
   rotate below 720px, where only one fits. Listens for viewport
   changes so resizing between the two behaviours is handled.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 720px)');

  document.querySelectorAll('[data-announce]').forEach(function (track) {
    var messages = track.querySelectorAll('[data-announce-msg]');
    if (messages.length < 2) return;

    var speed = parseInt(track.getAttribute('data-speed'), 10) || 4000;
    var index = 0;
    var timer = null;

    function show(n) {
      messages.forEach(function (msg, i) { msg.classList.toggle('is-active', i === n); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();                                  /* guard against stacked intervals */
      timer = setInterval(function () {
        index = (index + 1) % messages.length;
        show(index);
      }, speed);
    }
    function sync() {
      if (mobile.matches && !reduceMotion) {
        show(index);
        start();
      } else {
        /* desktop shows every message at once; reduced motion pins the first */
        stop();
        index = 0;
        show(0);
      }
    }

    sync();
    if (mobile.addEventListener) { mobile.addEventListener('change', sync); }
    else if (mobile.addListener) { mobile.addListener(sync); }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); }
      else if (mobile.matches && !reduceMotion) { start(); }
    });
  });
})();
